module.exports = __webpack_public_path__ + "img/1920_nav_img2.43976c70.png";